import React from 'react';
import PropTypes from 'prop-types';
import {Radio, FormControl, FormControlLabel, FormHelperText} from '@material-ui/core';
import useStyles from './RadioButtonStyles';

const RadioButton = ({label, labelPlacement, formControlLabelValue, radioValue, checked, disabled, onChange, radioInputProps, helperText, ...props}) => {

    const classes = useStyles();

    return (
        <FormControl disabled={disabled}>
            <FormControlLabel
                disabled={disabled}
                onChange={onChange}
                control={
                    <Radio
                        value={radioValue}
                        checked={checked}
                        disabled={disabled}
                        inputProps={radioInputProps}
                        classes={classes}
                        {...props}
                    />
                }
                value={formControlLabelValue}
                label={label}
                labelPlacement={labelPlacement}
            />
            {helperText && (
                <FormHelperText>
                    {helperText}
                </FormHelperText>
            )}
        </FormControl>
    );
};

RadioButton.propTypes = {
    label: PropTypes.node,
    labelPlacement: PropTypes.oneOf(['bottom', 'top', 'start', 'end']),
    formControlLabelValue: PropTypes.any,
    radioValue: PropTypes.any,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    radioInputProps: PropTypes.object,
    helperText: PropTypes.node,
};

RadioButton.defaultProps = {
    label: '',
    labelPlacement: 'end',
    formControlLabelValue: '',
    radioValue: '',
    checked: false,
    disabled: false,
    onChange: () => null,
    radioInputProps: {},
    helperText: '',
};

export default RadioButton;